import script from "./boxBottom.vue?vue&type=script&lang=ts&setup=true"
export * from "./boxBottom.vue?vue&type=script&lang=ts&setup=true"

import "./boxBottom.vue?vue&type=style&index=0&id=73165f4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73165f4e"]])

export default __exports__